export enum OrganizationTab {
  LoanOfficers = "loan-officers",
  Details = "details",
  Brands = "brands",
  Activity = "activity"
}
